export default "/images/e9acab3593aa463d0c4824d021cdab74.avif";